import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import useUser from "../../components/helpers/useUser";
import Loading from "../../components/shared/Loading";
import Toast from "../../components/shared/Toast";
import Tabs from "../../components/shared/Tabs";
import { CITIES, FIELDS, REVIEWS_TAGS } from "../../components/utils/constants";
import moment from "moment";
import ModalContainer from "../../containers/shared/ModalContainer";
import InputField from "../../components/shared/InputField";
import NormalButton from "../../components/shared/NormalButton";
import SingleTabDetails from "./singleTabs/details";
import SingleTabRequests from "./singleTabs/requests";
import SingleTabTransactions from "./singleTabs/transactions";
import SingleTabReviews from "./singleTabs/reviews";
import { useMediaQuery } from "../../components/helpers/useMediaQuery";

const SinglePage = () => {
    const {t,i18n} = useTranslation();
    const { id } = useParams();
    const [worker, setWorker] = useState(null);
    const [workerStatistics, setWorkerStatistics] = useState(null);
    useDocumentTitle(worker?.name ? worker?.name : t('nav.workers'));
    const navigate = useNavigate();
    const pageTitle = {title: worker?.name ? worker?.name : t('nav.workers')};
    const [user,setUser] = useUser();
    const [vendor, setVendor] = useState(null);
    const [toast, setToast] = useState({show: false,type: null, message:''});

    const [activeTab, setActiveTab] = useState(0);

    const [isActionLoading, setIsActionLoading] = useState(false);

    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [changePasswordForm, setChangePasswordForm] = useState({password: '', confirmPassword: '', username: worker?.username});

    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    const isMobile = useMediaQuery('(max-width: 768px)');

    const getUserData = async () => {
      try {
        const response = await apiClient.get(`/vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }

    const getWorker = async () => {
      try {
        const response = await apiClient.get(`/users?types=worker&limit=1&skip=0&partialUsername=${id}`);
        if(response?.data) {
          setWorker(response?.data[0]);
          getWorkerStatistics(response?.data[0]?._id);
        } else {

        }
      } catch(err) {}
    }

    const getWorkerStatistics = async (id) => {
        try {
            const response = await apiClient.get(`/requests/worker/statistics?workerId=${id}`);
            if(response?.data) {
                setWorkerStatistics(response?.data);
            } else {

            }
        } catch(err) {}
    }

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
            getWorker();
        }
    },[user])

    const workerTabs = [
        t('workerDetails.workerTabs.details'),
        t('workerDetails.workerTabs.requests'),
        t('workerDetails.workerTabs.transactions'),
        t('workerDetails.workerTabs.reviews')
    ];

    useEffect(()=>{
        if(moment) {
            moment?.locale('en-US');
        }
    },[])

    const closeModal = () => {
        setShowChangePasswordModal(false);
    }

    const handleClickChangePassword = () => {
        setShowChangePasswordModal(true);
        setIsSubmitDisabled(true);
        setChangePasswordForm({password: '', confirmPassword: ''});
    }

    const handleClickChangePasswordAction = async() => {
        setIsSubmitDisabled(true);
        setIsActionLoading(true);
        try {
            const response = await apiClient.post(`/users/setWorkerPassword`,changePasswordForm);
            if(response && response.status && (response.status === 201 || response.status === 200)) {
                setShowChangePasswordModal(false);
                setIsActionLoading(false);
                setToast({show:true,type:'success',message:t('workerDetails.changePasswordSuccess')});
            } else {
                setIsActionLoading(false);
                setIsSubmitDisabled(false);
                setToast({show:true,type:'error',message:t('workerDetails.changePasswordError')});
            }
        } catch (err) {
            setIsActionLoading(false);
            setIsSubmitDisabled(false);
            setToast({show:true,type:'error',message:t('workerDetails.changePasswordError')});
        }
    }

    useEffect(()=>{
        if(changePasswordForm?.password?.split("")?.length > 3 && changePasswordForm?.password && changePasswordForm?.confirmPassword && changePasswordForm?.password === changePasswordForm?.confirmPassword) {
            setIsSubmitDisabled(false);
        } else {
            setIsSubmitDisabled(true);
        }
    },[changePasswordForm])

    const openWorkerLocation = (lat, lng) => {
        window.open(`https://maps.google.com/?q=${lat},${lng}`, '_blank');
    };

    useEffect(()=>{
        if(vendor && !vendor?.activeSubscription) {
            navigate(`/${i18n?.language || 'ar'}/settings/packages`);
        }
    },[vendor])


    

    return (<>
        <PageHeader pageTitle={pageTitle} subTitleColored={true} />
        <PageMain>
            <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
            {vendor && worker && <MainContent>
                <Tabs itemWidth={isMobile ? 81 : 159} activeWidth={isMobile ? 100 : 185} animationWidth={isMobile ? 81 : 159} data={workerTabs} setActiveTab={setActiveTab} activeTab={activeTab} />

                {activeTab === 0 && <SingleTabDetails vendor={vendor} worker={worker} workerStatistics={workerStatistics} handleClickChangePassword={handleClickChangePassword} openWorkerLocation={openWorkerLocation} setIsActionLoading={setIsActionLoading} />}
                {activeTab === 1 && <SingleTabRequests workerId={worker?._id} setIsActionLoading={setIsActionLoading} />}
                {activeTab === 2 && <SingleTabTransactions workerId={worker?._id} setIsActionLoading={setIsActionLoading} />}
                {activeTab === 3 && <SingleTabReviews workerId={worker?._id} setIsActionLoading={setIsActionLoading} />}

            </MainContent>}
        </PageMain>

        { showChangePasswordModal && <ModalContainer maxWidth={'562px'} heading={t('workerDetails.changePasswordModal')} handleCloseModal={closeModal}>
            <div className="">
                <InputField isRequird label={t('workerDetails.passwordLabel')} value={changePasswordForm?.password} onChange={(e)=>{ if(e.target.value === '' || /^[0-9\b]+$/.test(e.target.value)) { setChangePasswordForm({ ...changePasswordForm, password: e.target.value }) }; }} />
                <InputField isRequird label={t('workerDetails.confirmPasswordLabel')} value={changePasswordForm?.confirmPassword} onChange={(e)=>{ if(e.target.value === '' || /^[0-9\b]+$/.test(e.target.value)) { setChangePasswordForm({ ...changePasswordForm, confirmPassword: e.target.value }) }; }} />
                <div className="w-full text-end pt-[14px]">
                    <NormalButton label={t('workerDetails.cancel')} color={'!bg-white !text-grey-400'} isDisabled={false} onClick={closeModal} />
                    <NormalButton label={t('workerDetails.changePasswordButton')} isDisabled={isSubmitDisabled} onClick={handleClickChangePasswordAction} />
                </div>
            </div>
        </ModalContainer> }

        <Toast toast={toast} setToast={setToast} />
        {(!vendor || !worker || isActionLoading) && <Loading showLoading={true} />}
    </>)
}

export default SinglePage;
